import PropTypes from 'prop-types';
import React from 'react';

import Browser from '@wetransfer/concorde-browser';

import I18n from '@module/i18n';

import Icon from '@component/icon';

import { WHITE } from '@constant/colors';

const AdGallery = ({
  placeholder,
  large,
  image,
  type,
  title,
  description,
  tags,
  onPreview,
  onTagSelect,
}) => {
  if (placeholder) {
    return (
      <div className="ad-gallery-item placeholder">
        <span className="ad-gallery-item__image" />
      </div>
    );
  }

  const classNames = ['ad-gallery-item'];
  if (large) {
    classNames.push('ad-gallery-item--is-large');
  }
  if (onPreview) {
    classNames.push('ad-gallery-item--is-clickable');
  }

  return (
    <div onClick={onPreview} className={classNames.join(' ')}>
      <span
        className="ad-gallery-item__image"
        style={{ backgroundImage: `url(${image})` }}
      />
      <span className="ad-gallery-item__gradient" />
      <span className="ad-gallery-item__type">{type}</span>
      <div className="ad-gallery-item__info">
        <span className="ad-gallery-item__title">{title}</span>
        {description && (
          <span
            className="ad-gallery-item__description"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
        {tags.length > 0 && (
          <div className="ad-gallery-item__tags">
            {tags
              .map((tag, index) => (
                <span
                  key={index}
                  className="ad-gallery-item__tag"
                  onClick={() => onTagSelect(tag)}
                >
                  {tag}
                </span>
              ))
              .reduce((prev, curr) => [prev, ', ', curr])}
          </div>
        )}
        {!Browser.isMobile && onPreview && (
          <a onClick={onPreview} className="ad-gallery-item__preview">
            {I18n.t('page.advertise.gallery.preview')}
            <Icon
              className="ad-gallery-item__icon"
              color={WHITE}
              type="ArrowCircle"
            />
          </a>
        )}
      </div>
    </div>
  );
};

AdGallery.propTypes = {
  placeholder: PropTypes.bool,
  large: PropTypes.bool,
  image: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  tags: PropTypes.array,
  onTagSelect: PropTypes.func,
  type: PropTypes.string,
  onPreview: PropTypes.func,
};

AdGallery.defaultProps = {
  placeholder: false,
  large: false,
  tags: [],
};

export default AdGallery;
